import { TopNav, PageShell, TailPageCTA, BackCoverFooter } from "@/app/components/brand-scaffold";
import { HomepageHeroEn } from "@/design-system/patterns/en/homepage-hero-en";
import {
  HomepageWhatIsHotlineEn,
  HomepageCallFlowEn,
  HomepageRealStatusEn,
  HomepagePathwaysEn,
  HomepageWhyNotJustEn,
  HomepageMarketplacePreviewEn,
  HomepageOpenSourceEn,
  HomepageFaqEn,
} from "@/design-system/patterns/en/homepage-sections-en";
import { siteHeaderActionsEn, siteNavItemsEn } from "@/app/content-en";

export default function EnglishHomePage() {
  return (
    <PageShell>
      <TopNav navItems={siteNavItemsEn} actionItems={siteHeaderActionsEn} homeHref="/en" />
      <main className="relative z-10 w-full overflow-hidden">
        <HomepageHeroEn />
        <HomepageWhatIsHotlineEn />
        <HomepageCallFlowEn />
        <HomepageRealStatusEn />
        <HomepagePathwaysEn />
        <HomepageWhyNotJustEn />
        <HomepageMarketplacePreviewEn />
        <HomepageOpenSourceEn />
        <HomepageFaqEn />
        <TailPageCTA />
      </main>
      <BackCoverFooter />
    </PageShell>
  );
}
